export const expensecategory = [
  {
    id: "1",
    status:"Active",
    categoryName: "Employee Benefits",
    description: "Employee Vehicle",
    isSelected: false,
  },
  {
    id: "2",
    status:"Active",
    categoryName: "Foods & Snacks",
    description: "Employee Foods",
    isSelected: false,
  },
  {
    id: "3",
    status:"Active",
    categoryName: "Entertainment",
    description: "Employee Welfare",
    isSelected: false,
  },
  {
    id: "4",
    status:"Active",
    categoryName: "Office Expenses & Postage",
    description: "Postal Expense",
    isSelected: false,
  },
  {
    id: "5",
    status:"Active",
    categoryName: "Other Expenses",
    description: "Other Expenses",
    isSelected: false,
  },
  {
    id: "6",
    status:"Active",
    categoryName: "Petrol",
    description: "Employee Cab",
    isSelected: false,
  },
  {
    id: "7",
    status:"Active",
    categoryName: "Maintenance",
    description: "Office Maintenance",
    isSelected: false,
  },
  {
    id: "8",
    status:"Active",
    categoryName: "Marketing",
    description: "Advertising Cost",
    isSelected: false,
  },
  {
    id: "9",
    status:"Active",
    categoryName: "Printing & Stationery",
    description: "Stationery Expense",
    isSelected: false,
  },
  {
    id: "10",
    status:"Active",
    categoryName: "Telephone Expense",
    description: "Telephone Cost",
    isSelected: false,
  },
];
